import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

// Handles a `?<param>=<id>` deep link (reports page, and every entity link
// rendered by `EntityLink`): calls `open(id)` — the page-specific fetch +
// detail-modal open + error reporting — then drops the param so a
// refresh/close doesn't reopen it and the URL stays clean. The ref holds the
// id in flight so re-renders don't re-trigger it, and is cleared once the
// param is dropped so a later link to the same page (a genre's neighbour
// inside the genre modal) opens too.
export function useEntityDeepLink(param, open) {
  const [searchParams, setSearchParams] = useSearchParams();
  const handlingRef = useRef(null);

  useEffect(() => {
    const id = searchParams.get(param);
    if (!id || handlingRef.current === id) return;
    handlingRef.current = id;
    (async () => {
      try {
        await open(id);
      } finally {
        const next = new URLSearchParams(searchParams);
        next.delete(param);
        setSearchParams(next, { replace: true });
        handlingRef.current = null;
      }
    })();
  }, [param, open, searchParams, setSearchParams]);
}
